import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SubscriptionProvider } from "@/contexts/SubscriptionContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Generate from "@/pages/Generate";
import NoteViewer from "@/pages/NoteViewer";
import Teams from "@/pages/Teams";
import PublicNote from "@/pages/PublicNote";
import AuthCallback from "@/pages/AuthCallback";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";

function AppRouter() {
  const location = useLocation();
  // Intercept Emergent Google OAuth callback: /...#session_id=... arrives here
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/share/:slug" element={<PublicNote />} />
      <Route path="/terms" element={<Terms />} />

      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/app/new" element={<ProtectedRoute><Generate /></ProtectedRoute>} />
      <Route path="/app/note/:id" element={<ProtectedRoute><NoteViewer /></ProtectedRoute>} />
      <Route path="/app/teams" element={<ProtectedRoute><Teams /></ProtectedRoute>} />
      <Route path="/app/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/app/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SubscriptionProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton />
        </SubscriptionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
